import { Outlet } from 'react-router-dom';
import { useApiHealth } from '../hooks/useApiHealth';
import { DomainModalProvider } from '../components/DomainModalContext';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';

export function AppShell() {
  const health = useApiHealth();

  return (
    <DomainModalProvider>
      <div className="flex h-full bg-bg text-text font-sans">
        <Sidebar health={health} />
        <main className="flex-1 flex flex-col min-w-0 h-full">
          <TopBar />
          <div className="flex-1 min-h-0 flex flex-col overflow-auto">
            <Outlet />
          </div>
        </main>
      </div>
    </DomainModalProvider>
  );
}
